// Pure mappers from a user_event row to the shapes the rest of the app expects.
// The 'event:' prefix keeps custom-event ids from colliding with catalog unique_ids.
export function toOverlapItem(event) {
    return {
        unique_id: `event:${event.id}`,
        title: event.title,
        start_date_and_time: event.startTime,
        end_date_and_time: event.endTime,
    };
}

export function normalizeEventForCard(event) {
    return {
        id: event.id,
        unique_id: `event:${event.id}`,
        title: event.title,
        start_date_and_time: event.startTime,
        end_date_and_time: event.endTime,
        is_my_event: true,
        // Braindates are My Events that were synced in from Bizzabo rather than
        // typed in by the attendee. Surfaced here, at the one boundary every
        // card already goes through, so no card has to reach into the raw row —
        // and so a card that does not care about the distinction keeps working
        // unchanged.
        is_braindate: event.source === 'braindate',
        // The Braindate permalink for synced rows, null otherwise. Carried on
        // the row by the import; see the migration for why it is not looked up.
        event_url: event.url ?? null,
        _event: event,
    };
}
